import React from "react";

interface HandleFeedbackProps {
  instructions: string;
  answer: React.MutableRefObject<boolean | null>;
  setChampsProfondActif: React.Dispatch<React.SetStateAction<boolean>>;
  successCountRef: React.MutableRefObject<number>;
  failureCountRef: React.MutableRefObject<number>;
}

const HandleFeedback = ({
  instructions,
  answer,
  setChampsProfondActif,
  successCountRef,
  failureCountRef,
}: HandleFeedbackProps) => {
  
  // Function to handle the user's answer and update the success or failure count refs
  function handleAnswer(answerQuestion: boolean) {
    if (answerQuestion === answer.current) {
      successCountRef.current += 1; // Update successCount using ref
    } else {
      failureCountRef.current += 1; // Update failureCount using ref
    }
    setChampsProfondActif(true); // Reactivate Champs Profond
  }

  return (
    <div
      style={{
        backgroundColor: 'black',
        color: 'white',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
      className="cursor-default"
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          background: "rgba(0, 0, 0, 0.8)",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <p>{instructions}</p>
        <button
          onClick={() => handleAnswer(true)}
          className="font-bold bg-sidebar"
          style={{
            margin: "10px",
            padding: "10px 20px",
            fontSize: "16px",
            border: "none",
            borderRadius: "5px",
            color: "white",
          }}
        >
          Oui
        </button>
        <button
          onClick={() => handleAnswer(false)}
          className="font-bold bg-sidebar"
          style={{
            margin: "10px",
            padding: "10px 20px",
            fontSize: "16px",
            border: "none",
            borderRadius: "5px",
            color: "white",
          }}
        >
          Non
        </button>
      </div>
    </div>
  );
};

export default HandleFeedback;
